import { Injectable, OnDestroy } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";

import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { firebase } from '@firebase/app';

import { AngularFireObject } from "angularfire2/database";
import { BackendService } from "../../_services/backend-service";
import { User } from '../user'
import { NgProgress } from "ngx-progressbar";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs/Subject";
import { environment } from "../../../environments/environment";
declare let FS: any;

@Injectable()
export class UserService implements OnDestroy {
    user: User;
    userId: string;
    agencyId: string;
    userLevel: number = 5; // 5 is the FREE tier
    dbUser: User;
    avatar: string;
    unsubscribe: any;

    constructor(
        private afAuth: AngularFireAuth,
        private afs: AngularFirestore,
        private backendService: BackendService,
        // private userDoc: AngularFirestoreDocument<any>,
        private http: Http,
        public ngProgress: NgProgress,
        private toastr: ToastrService
    ) {
        this.unsubscribe = new Subject();
        this.verify();
        // this.update();
    }

    ngOnDestroy() {
        console.debug('Destroying User Service Component...');
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    update(uid, data): Promise<any> {
        console.debug('Updating User: ', uid);
        let userRef = this.afs.collection('users').doc(uid);
        return userRef.update(data);
    };

    verify() {
        return new Promise((resolve, reject) => {
            console.debug('* VERIFY TOKEN PROMISE *');
            this.afAuth.auth.onAuthStateChanged(auth => {
                if (auth) {
                    console.debug('auth', auth);
                    auth.getIdToken(true)
                        .then((idToken) => {
                            console.debug('token', idToken);
                            localStorage.removeItem('authRedirect');
                            // Get User from DB
                            let userRef = this.afs.collection('users').doc(auth.uid);
                            console.debug('auth = ', auth);
                            userRef.valueChanges().take(1).subscribe(d => {
                                this.dbUser = d as User;
                                console.debug('DB USER : ', this.dbUser);
                                if (this.dbUser) {
                                    this.user = this.dbUser;
                                    this.user.uid = auth.uid;
                                    this.userId = auth.uid;
                                    this.user.token = idToken;
                                    this.user.userLevel = this.userLevel = this.dbUser.userLevel;
                                    localStorage.setItem('currentUser', JSON.stringify(this.user));
                                    localStorage.setItem('token', idToken);
                                    this.afs.collection('users').doc(auth.uid).ref.set({
                                        lastLoginTime: (new Date()).toString()
                                    }, { merge: true }).then(() => {
                                        resolve(idToken);
                                    }, error => {
                                        console.error(error);
                                        reject(error);
                                    });
                                }
                                else {
                                    reject('Cannot find this User ref in DB');
                                }
                            });
                            // Set FS User's details
                            if (environment.production) {
                                if (auth && (auth.displayName || auth.email)) {
                                    console.debug('setting user id for fullstory:', auth.uid);
                                    FS.identify(this.userId, {
                                        displayName: auth.displayName || auth.email,
                                        email: auth.email,
                                    });
                                }
                            }
                        })
                }
                else {
                    console.debug('Not Authenticated..');
                    resolve(null);
                    if (environment.production) {
                        FS.clearUserCookie();
                    }
                }
            },
                error => {
                    console.error('NOT AUTHENTICATED !', error);
                    reject(error);
                })
        });
    }

    forgotPassword(email: string) {
        console.debug('User forgot password');
        return this.afAuth.auth.sendPasswordResetEmail(email);
    }

    // getAll() {
    //     console.debug('Getting All...');
    //     return this.http.get('/api/users', this.jwt()).map((response: Response) => response.json());
    // }
    //
    // getById(id: number) {
    //     console.debug('Getting user by ID...');
    //     return this.http.get('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    // }

    changePassword(currentPassword: string, newPassword: string) {
        const currentUser = this.afAuth.auth.currentUser;
        let cred: any;
        cred = firebase.auth.EmailAuthProvider.credential(this.user.email, currentPassword);
        return new Promise((resolve, reject) => {
            currentUser.reauthenticateWithCredential(cred)
                .then(function() {
                    currentUser.updatePassword(newPassword)
                        .then(function() {
                            console.debug('updated new password successfully');
                            resolve()
                        },
                        error => {
                            console.error(error);
                            reject(error)
                        })
                },
                error => {
                    console.error(error);
                    if (error.code == 'auth/wrong-password') {
                        error.message = 'You typed a wrong password for your current password!'
                    }
                    this.toastr.error(error.message, 'Error', { timeOut: 5000 });
                }
                )
        })
    }

    handleFBLogin() {
        return new Promise((resolve, reject) => {
            this.afAuth.auth.signInWithPopup(new firebase.auth.FacebookAuthProvider()).then(authResult => {
                console.debug('Facebook Login Result: ', authResult);
                const auth = authResult.user;

                let userRef = this.afs.collection('users').doc(auth.uid);
                this.afs.doc('/users/' + auth.uid).snapshotChanges().take(1).subscribe(d => {
                    if (d.payload.exists) { // Check if the User document is exist on DB (if not create a new record for this user)
                        console.debug('Updating Existing User in DB...');
                        userRef.update({
                            fullName: auth.displayName || null,
                            displayName: auth.displayName || null,
                            email: auth.email || null,
                            image: auth.providerData[0].photoURL || null,
                            providerUserInfo: {
                                'providerId': auth.providerData[0].providerId || 'facebook.com',
                                'id': auth.providerData[0].uid || null,
                                'email': auth.providerData[0].email || null,
                                'displayName': auth.providerData[0].displayName || null,
                                'photoURL': auth.providerData[0].photoURL || null
                            },
                            lastLoginTime: (new Date()).toString()
                        }).then(result => {
                            resolve(auth)
                        })
                    }
                    else { // If User is not exist in DB
                        console.debug('Creating Profile in DB and generating an Agency ID');
                        userRef.set({
                            // Create agencyId in order to bind resources (artists, bookings, etc.. to this Id)
                            agencyId: this.afs.createId(),
                            fullName: auth.displayName || null,
                            displayName: auth.displayName || null,
                            email: auth.email || null,
                            userLevel: 5,
                            image: auth.providerData[0].photoURL || null,
                            providerUserInfo: {
                                'providerId': auth.providerData[0].providerId || 'facebook.com',
                                'id': auth.providerData[0].uid || null,
                                'email': auth.providerData[0].email || null,
                                'displayName': auth.providerData[0].displayName || null,
                                'photoURL': auth.providerData[0].photoURL || null
                            },
                            lastLoginTime: (new Date()).toString()
                        }).then(result => {
                            resolve(auth)
                        })
                    }
                });
            }, error => {
                console.error('Error logging in with Facebook');
                console.error(error);
                reject(error);
            })
        })
    }

    // updateFBUser(user: User) {
    //     return new Promise((resolve, reject) => {
    //         console.debug('Entered Update FB User Function...');
    //         this.afAuth.auth.onAuthStateChanged(auth => {
    //             console.debug(auth);
    //
    //             let userRef = this.afs.collection('users').doc(auth.uid);
    //             this.afs.doc('/users/' + auth.uid).snapshotChanges().take(1).subscribe(d => {
    //                 if (!d.payload.exists) {
    //                     console.debug('This user profile exist in DB ?' + !d.payload.exists);
    //                     console.debug('Updating Profile in DB and generating an Agency ID');
    //                     userRef.set({
    //                         // Create agencyId in order to bind resources (artists, bookings, etc.. to this Id)
    //                         agencyId: this.afs.createId(),
    //                         fullName: user.fullName || auth.displayName || null,
    //                         displayName: auth.displayName || user.fullName || null,
    //                         email: auth.email || null,
    //                         image: user.image,
    //                         facebookProfile: user.facebookProfile,
    //                         // image: this.backendService.generateAvatar(auth.displayName || user.fullName || auth.email),
    //                         // image: this.avatar || null,
    //                         lastLoginTime: (new Date()).toString(),
    //                     })
    //                 }
    //             });
    //
    //             // if (!user.image) {
    //             //     // Generate avatar by user's initials
    //             //     this.backendService.generateAvatar(auth.displayName || user.fullName || auth.email).subscribe(url => {
    //             //         this.avatar = url;
    //             //         userRef.update({ image: this.avatar || null });
    //             //     });
    //             // }
    //             resolve(auth);
    //                 },
    //                 error => {
    //                     console.error(error);
    //                     reject(error);
    //                 })
    //     });
    //     // return this.afAuth.auth.createUserWithEmailAndPassword(user.email, user.password);
    //     // return this.http.post('/api/users', user, this.jwt()).map((response: Response) => response.json());
    // }

    create(user: User) {
        return new Promise((resolve, reject) => {
            this.afAuth.auth.createUserWithEmailAndPassword(user.email, user.password)
                .then(auth => {
                    console.debug(auth);

                    let userRef = this.afs.collection('users').doc(auth.uid);

                    userRef.set({
                        // Create agencyId in order to bind resources (artists, bookings, etc.. to this Id)
                        agencyId: this.afs.createId(),
                        fullName: user.fullName || auth.displayName || null,
                        displayName: auth.displayName || user.fullName || null,
                        email: auth.email || null,
                        image: null,
                        lastLoginTime: (new Date()).toString(),
                    });

                    // Generate avatar by user's initials
                    this.backendService.generateAvatar(auth.displayName || user.fullName || auth.email).subscribe(url => {
                        console.debug('Generating avatar for user: ', auth.displayName || user.fullName);
                        this.avatar = url;
                        userRef.update({ image: this.avatar || null });
                    });

                    resolve(auth);
                },
                error => {
                    var e = error;
                    if (error.code == 'auth/email-already-in-use') {
                        e.message = 'You already have an account linked to the email address... ' + '\n\n Try to sign in with Facebook instead of using your email address.';
                    }
                    console.error(error);
                    reject(e);
                })
        });
    }

    // createUserInDB(user: User) {
    //     this.afAuth.auth.onAuthStateChanged(auth => {
    //         if (auth) {
    //             let userRef = this.afs.collection('users').doc(auth.uid);
    //             userRef.set({
    //                 agencyId: "new",
    //                 displayName: auth.displayName || null,
    //                 fullName: user.fullName || null,
    //                 email: auth.email || null,
    //                 lastLoginTime: (new Date()).toString
    //             })
    //         }
    //     });
    // }

    // delete(id: number) {
    //     return this.http.delete('/api/users/' + id, this.jwt()).map((response: Response) => response.json());
    // }

    // private helper methods

    private jwt() {
        // create authorization header with jwt token
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.token) {
            let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
            return new RequestOptions({ headers: headers });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_services/user.service.ts